import React from 'react';
import Icon from '../../../components/AppIcon';
import AppImage from '../../../components/AppImage';

const MemberSpotlight = () => {
  const spotlightMembers = [
    {
      id: 1,
      name: 'Sarah Tech',
      avatar: 'https://api.dicebear.com/7.x/avataaars/svg?seed=SarahTech',
      achievement: 'Completed 100 workouts this year',
      badge: 'Century Club',
      icon: 'Trophy'
    },
    {
      id: 2,
      name: 'Mike Developer',
      avatar: 'https://api.dicebear.com/7.x/avataaars/svg?seed=MikeDev',
      achievement: 'Lost 25 lbs in 3 months',
      badge: 'Transformation',
      icon: 'TrendingDown'
    }
  ];

  return (
    <div className="bg-card rounded-xl shadow-md p-6">
      <div className="flex items-center justify-between mb-6">
        <h2 className="text-xl font-bold text-foreground">Member Spotlight</h2>
        <Icon name="Star" size={24} className="text-yellow-500" />
      </div>

      <div className="space-y-4">
        {spotlightMembers?.map((member) => (
          <div key={member?.id} className="flex items-start gap-4 p-4 bg-accent/30 rounded-lg hover-lift transition-smooth">
            <AppImage
              src={member?.avatar}
              alt={member?.name}
              className="w-16 h-16 rounded-full object-cover"
            />
            <div className="flex-1">
              <div className="flex items-center gap-2 mb-2">
                <h3 className="font-semibold text-foreground">{member?.name}</h3>
                <div className="flex items-center gap-1 px-2 py-1 bg-primary/10 rounded-full">
                  <Icon name={member?.icon} size={12} className="text-primary" />
                  <span className="text-xs font-medium text-primary">{member?.badge}</span>
                </div>
              </div>
              <p className="text-sm text-muted-foreground">{member?.achievement}</p>
            </div>
          </div>
        ))}
      </div>

      <div className="mt-6 text-center">
        <p className="text-sm text-muted-foreground">
          Want to be featured? Share your journey in the community feed!
        </p>
      </div>
    </div>
  );
};

export default MemberSpotlight;